import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import { formatActivityTime } from '../../util/dateHelpers';

// Create styles
const styles = StyleSheet.create({
  section: {
    margin: 10,
    padding: 10,
  },
  header: {
    flexDirection: 'row',
    margin: 10,
    padding: 10,
    alignItems: 'center',
  },
  item: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '24px',
  },
  itemName: {
    fontSize: '20px',
    fontWeight: 'bold',
    lineHeight: 1.6,
  },
  itemIcon: {
    width: '36px',
  },
  logo: {
    marginRight: '16px',
    width: '60px',
  },
  itemDetails: {
    marginLeft: '16px',
  },
  detailsIcon: {
    marginRight: '8px',
    width: '12px',
  },
  itemDetailRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  reportName: {
    fontSize: '30px',
  },
});

// Create Document Component
const CardholderActivityReport = (props) => {
  const { data, logo } = props;
  const renderedItems = data.map((record) => {
    const formattedTime = `${formatActivityTime(record.transTime, true)}`;
    let icon = null;
    let credentialIcon = null;
    if (record.description.includes('Access Granted')) {
      icon = <Image src={`${window.location.origin}/images/green-door-open.png`} />;
      credentialIcon = <Image src={`${window.location.origin}/images/blue-card.png`} />;
    } else {
      icon = <Image src={`${window.location.origin}/images/red-door-closed-lock.png`} />;
      credentialIcon = <Image src={`${window.location.origin}/images/blue-card.png`} />;
    }
    // switch (record.type) {
    //   case 'granted-card':
    //     icon = <Image src={`${window.location.origin}/images/green-door-open.png`} />;
    //     credentialIcon = <Image src={`${window.location.origin}/images/blue-card.png`} />;
    //     break;
    //   case 'denied-card':
    //     icon = <Image src={`${window.location.origin}/images/red-door-closed-lock.png`} />;
    //     credentialIcon = <Image src={`${window.location.origin}/images/blue-card.png`} />;
    //     break;
    //   case 'granted-mobile':
    //     icon = <Image src={`${window.location.origin}/images/green-cellphone.png`} />;
    //     credentialIcon = <Image src={`${window.location.origin}/images/blue-cellphone.png`} />;
    //     break;
    //   case 'denied-mobile':
    //     icon = <Image src={`${window.location.origin}/images/red-cellphone.png`} />;
    //     credentialIcon = <Image src={`${window.location.origin}/images/blue-cellphone.png`} />;
    //     break;
    //   case 'new-mobile':
    //     icon = <Image src={`${window.location.origin}/images/blue-cellphone-key.png`} />;
    //     credentialIcon = <Image src={`${window.location.origin}/images/blue-cellphone.png`} />;
    //     break;
    //   default:
    //     icon = null;
    //     credentialIcon = null;
    // }

    return (
      <View style={styles.item} key={record.id}>
        <View style={styles.itemIcon}>{icon}</View>
        <View style={styles.itemDetails}>
          <Text style={styles.itemName}>{record.description}</Text>
          <View style={styles.itemDetailRow}>
            {/* {selectNameIcon()} */}
            <View style={styles.detailsIcon}>{credentialIcon}</View>
            <Text>{record.cardNumber}</Text>
          </View>
          <View style={styles.itemDetailRow}>
            {/* <WatchLaterIcon style={styles.detailsIcon} /> */}
            <View style={styles.detailsIcon}>
              <Image src={`${window.location.origin}/images/blue-clock.png`} />
            </View>
            <Text>{formattedTime}</Text>
          </View>
        </View>
      </View>
    );
  });
  return (
    <Document>
      <Page size="LETTER">
        <View style={styles.header}>
          <View style={styles.logo}>
            <Image src={logo} />
          </View>
          <Text style={styles.reportName}>Cardholder Activity Report</Text>
        </View>
        <View style={styles.section} />
        <View style={styles.section}>{renderedItems}</View>
      </Page>
    </Document>
  );
};
export default CardholderActivityReport;
